/*
 * scroll-rail.js
 * Progressive enhancement for the shared mobile scroll rail.
 *
 * Wires prev/next arrows (snippets/scroll-rail-arrows.liquid) to the rail track.
 * Without this script the rail still works as native finger-swipe; arrows stay
 * hidden until .scroll-rail--ready is added.
 */
(function () {
  if (window.__loftsailsScrollRailInit) return;
  window.__loftsailsScrollRailInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function preventMisclick(track) {
    var startX = 0;
    var startY = 0;
    var didSwipe = false;

    track.addEventListener(
      'touchstart',
      function (event) {
        var touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
        didSwipe = false;
      },
      { passive: true },
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        var touch = event.touches[0];
        if (!touch) return;
        var dx = Math.abs(touch.clientX - startX);
        var dy = Math.abs(touch.clientY - startY);
        if (dx > 10 && dx > dy) didSwipe = true;
      },
      { passive: true },
    );

    track.addEventListener(
      'click',
      function (event) {
        if (!didSwipe) return;
        event.preventDefault();
        event.stopPropagation();
        didSwipe = false;
      },
      true,
    );
  }

  function initRail(group) {
    if (!group || group.classList.contains('scroll-rail--ready')) return;

    var track = group.querySelector('[data-rail-track]');
    if (!track) return;

    var prev = group.querySelector('[data-rail-prev]');
    var next = group.querySelector('[data-rail-next]');

    function stepDistance() {
      var first = track.children[0];
      if (!first) return track.clientWidth * 0.8;
      var width = first.getBoundingClientRect().width;
      if (width < 1) {
        var nodes = first.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          var descendantWidth = nodes[i].getBoundingClientRect().width;
          if (descendantWidth > 1) {
            width = descendantWidth;
            break;
          }
        }
      }
      if (width < 1) width = track.clientWidth * 0.8;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return width + gap;
    }

    function scrollByDir(dir) {
      track.scrollBy({
        left: dir * stepDistance(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    function update() {
      var canScroll = track.scrollWidth - track.clientWidth > 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (prev) prev.disabled = !canScroll || atStart;
      if (next) next.disabled = !canScroll || atEnd;
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    track.addEventListener('scroll', update, { passive: true });
    var resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(track);
    group.loftsailsRailDestroy = () => resizeObserver.disconnect();
    preventMisclick(track);

    group.classList.add('scroll-rail--ready');
    update();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var groups = scope.querySelectorAll('[data-rail-group]');
    for (var i = 0; i < groups.length; i++) initRail(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-rail-group]').forEach(group => group.loftsailsRailDestroy?.());
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
